export const MOVEMENT_TYPES = ['entry', 'depletion', 'discard', 'adjustment', 'transfer'];
export const SHOPPING_ORIGINS = ['auto_depletion', 'manual'];
export const SHOPPING_STATUSES = ['pending', 'purchased'];
export const PRODUCT_SOURCES = ['manual', 'external', 'photo'];
/** Verde / amarelo / vermelho da UI. `unknown` = item sem validade conhecida. */
export const EXPIRY_STATUSES = ['unknown', 'ok', 'warning', 'expired'];
//# sourceMappingURL=types.js.map